import { render, staticRenderFns } from "./PieChartWidget.vue?vue&type=template&id=2177246c&"
import script from "./PieChartWidget.vue?vue&type=script&lang=ts&"
export * from "./PieChartWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports